import React, { useState, useEffect } from 'react';

import YouTube from '@mui/icons-material/YouTube';

import Video from '../../../pages/activities/Video'
import ActivityButton from './ActivityButton';

import Congratulations from '../Congratulations';
import { useCode } from '../../../contexts/Code';
import { useAuth } from '../../../contexts/auth'

import { useCheckActivityCompleted, completeActivity }  from '../../../hooks/activity'

const ActivityVideo = ({ session, activity, metadata }) => {
  const {code} = useCode()
  const {user} = useAuth()

  const isCompleted = useCheckActivityCompleted(activity);

  const [openVideo, setOpenVideo] = useState(false);
  const [videoEnded, setVideoEnded] = useState(false);
  const [congratulations, setCongratulations] = useState(false);

  useEffect(()=> {
    setVideoEnded(isCompleted)
  }, [isCompleted])

  if (!code) return null;

  return (
    <>
      <Video 
        activity={activity} 
        session={session} 
        videoEnded={videoEnded} 
        videoUrl={metadata ? metadata.videoUrl :'https://www.youtube-nocookie.com/embed/-Rds69zhs3o'} 
        openVideo={openVideo} 
        setOpenVideo={setOpenVideo} 
        setCongratulations={setCongratulations} />

      <Congratulations fire={congratulations} message={code === 45 ? `Congratulations, you have accumulated ${activity ? activity.score : 100} points!` : `¡Felicidades, has acumulado ${activity ? activity.score : 100} puntos!`} />

      <ActivityButton
        title={code == 45 ? "Watch video" : "Ver video"}
        subtitle={`+${activity ? activity.score : 100} ${code === 45 ? "points" : "puntos"}`}
        icon={<YouTube />}
        iconColor="error"
        clickWrapper={(e) => {
          setOpenVideo(true);
          setTimeout(() => {
            setVideoEnded(true);
            setCongratulations(true)
            completeActivity(user, activity);

            localStorage.setItem(code+session.id+'yt', 'true') // DEMO
          }, 60 * 1000 * 2.6);
        }}
        check={videoEnded}
        image={"https://i.imgur.com/QZfkrX4.png"}
      />
    </>
  );
};

export default ActivityVideo;